import {CanActivateFn} from '@angular/router';
import {AuthService} from "./auth.service";
import {inject} from "@angular/core";
import {Observable} from "rxjs";

export const authGuard: CanActivateFn = (_route, state): true | Observable<boolean> => {

  const authService: AuthService = inject(AuthService);
  return authService.isAuthenticated() ? true : authService.authenticate(state.url);
};
